import React, { Component } from 'react';
import ContainerClass from './drag_container';
import { Container } from 'reactstrap';

class CalenderView extends Component {

	render() {

		const PeriodicData = [
			{ id: '1', name: 'Bathroom floor',is_charged:true },
			{ id: '2', name: 'Full window clean',is_charged:false },
			{ id: '3', name: 'Lounge chairs   ',is_charged:true },
			{ id: '4', name: 'Dining room Chairs',is_charged:false },
			{ id: '5', name: 'High level Cleaning',is_charged:false }
		];
		
		const YearList=[
            {id:'1',month_name:'Jul',year:'2017'},
            {id:'2',month_name:'Aug',year:'2017'},
            {id:'3',month_name:'Sep',year:'2017'},
            {id:'4',month_name:'Oct',year:'2017'},
            {id:'5',month_name:'Nov',year:'2017'},
            {id:'6',month_name:'Dec',year:'2017'},
            {id:'7',month_name:'Jan',year:'2018'},
            {id:'8',month_name:'Feb',year:'2018'},
            {id:'9',month_name:'Mar',year:'2018'},
            {id:'10',month_name:'Apr',year:'2018'},
            {id:'11',month_name:'May',year:'2018'},
            {id:'12',month_name:'Jun',year:'2018'},
            {id:'13',month_name:'Jul',year:'2018'},
            {id:'14',month_name:'Aug',year:'2018'},
            {id:'15',month_name:'Sep',year:'2018'},
            {id:'16',month_name:'Oct',year:'2018'},
            {id:'17',month_name:'Nov',year:'2018'},
            {id:'18',month_name:'Dec',year:'2018'}
        ]

		var user_data = [{ id: "1", name: "FS" }, { id: "2", name: "AL" },{ id: "3", name: "BL" }];

		return (
			<Container fluid = {true} >
					<div className="row fix-scroll row-padding">
						<div className="row no-wrap-box">
							{YearList.map(x=>
								<ContainerClass key={x.id} id={x.id} list={PeriodicData} toggle={this.toggle} month_name={x.month_name} year={x.year} user_data={user_data} toggle={this.props.toggle}/>
							)}
						</div>
					</div>
			</Container>
		);
	}
}

export default CalenderView;


// WEBPACK FOOTER //
// ./src/shared/containers/CalenderView/index.js